// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-d9ce03a8]{transition:opacity .5s 1s}.fade-leave-active[data-v-d9ce03a8]{transition:opacity .5s}.fade-enter[data-v-d9ce03a8],.fade-leave-to[data-v-d9ce03a8]{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
